import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'msfNumber',
  standalone: true,
})
export class MsfNumber implements PipeTransform {
  transform(value?: number | string | undefined | null,  locale: string = 'en-US'): string | null {
    if (value == null || value === '') return null;
    const num = typeof value === 'string' ? Number(value) : value;
    if (isNaN(num)) return null;

    const options: Intl.NumberFormatOptions = {
      useGrouping: false,
      maximumFractionDigits: 2
    };

    return new Intl.NumberFormat('en-US', options).format(num);
  }
}
